/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import Register from "./Register.container";

export default Register;
